export default __webpack_public_path__ + "static/media/Logo transparent (512x512px) PNG (WO- BG).c2c0ea6e.png";